export const MS_IN_SECOND = 1000;
export const SECONDS_IN_HOUR = 3600;
export const SECONDS_IN_MIN = 60;

export const USER_FRIENDLY_NAME_QS_KEY = "userFriendlyName";
